/*!
 * Bootstrap Modal v4.1.3 (standalone, jQuery-required)
 * Lightweight extraction – only the Modal component.
 * Licensed under MIT
 */
+function ($) {
  'use strict';

  // ─── Util ─────────────────────────────────────────────────────────────────

  var Util = (function () {
    var TRANSITION_END = 'transitionend';

    function getSpecialTransitionEndEvent() {
      return {
        bindType: TRANSITION_END,
        delegateType: TRANSITION_END,
        handle: function (event) {
          if ($(event.delegateTarget).is(this)) {
            return event.handleObj.handler.apply(this, arguments);
          }
          return undefined;
        }
      };
    }

    function transitionEndEmulator(duration) {
      var called = false;
      $(this).one(Util.TRANSITION_END, function () { called = true; });
      setTimeout(function () { if (!called) { $(this).trigger(Util.TRANSITION_END); } }.bind(this), duration);
      return this;
    }

    function setTransitionEndSupport() {
      $.fn.emulateTransitionEnd = transitionEndEmulator;
      $.event.special[Util.TRANSITION_END] = getSpecialTransitionEndEvent();
    }

    return {
      TRANSITION_END: 'bsTransitionEnd',
      reflow: function (element) { return element.offsetHeight; },
      getTransitionDurationFromElement: function (element) {
        if (!element) return 0;
        var duration = $(element).css('transition-duration');
        if (!duration) return 0;
        duration = duration.split(',')[0];
        return parseFloat(duration) * 1000;
      },
      supportsTransitionEnd: function () { return Boolean(TRANSITION_END); },
      setTransitionEndSupport: setTransitionEndSupport
    };
  })();

  Util.setTransitionEndSupport();

  // ─── Modal ────────────────────────────────────────────────────────────────

  var NAME               = 'modal';
  var DATA_KEY           = 'bs.modal';
  var ESCAPE_KEYCODE     = 27;

  var Default = {
    backdrop : true,
    keyboard : true,
    focus    : true,
    show     : true
  };

  // Bootstrap 4 class names
  var ClassName = {
    SCROLLBAR_MEASURER : 'modal-scrollbar-measure',
    BACKDROP           : 'modal-backdrop',
    OPEN               : 'modal-open',
    FADE               : 'fade',
    SHOW               : 'show'  // B4 uses 'show' (not 'in')
  };

  var Modal = function (element, config) {
    this._config        = $.extend({}, Default, config);
    this._element       = element;
    this._dialog        = $(element).find('.modal-dialog')[0];
    this._backdrop      = null;
    this._isShown       = false;
    this._isBodyOverflowing = false;
    this._ignoreBackdropClick = false;
    this._scrollbarWidth = 0;
  };

  Modal.prototype.toggle = function (relatedTarget) {
    return this._isShown ? this.hide() : this.show(relatedTarget);
  };

  Modal.prototype.show = function (relatedTarget) {
    var _this = this;
    if (this._isShown) return;

    var showEvent = $.Event('show.bs.modal', { relatedTarget: relatedTarget });
    $(this._element).trigger(showEvent);
    if (showEvent.isDefaultPrevented()) return;

    this._isShown = true;

    this._checkScrollbar();
    this._setScrollbar();
    $(document.body).addClass(ClassName.OPEN);

    this._setEscapeEvent();

    $(this._element).on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this));

    this._showBackdrop($.proxy(this._showElement, this, relatedTarget));
  };

  Modal.prototype.hide = function (event) {
    if (event) event.preventDefault();
    if (!this._isShown) return;

    var hideEvent = $.Event('hide.bs.modal');
    $(this._element).trigger(hideEvent);
    if (hideEvent.isDefaultPrevented()) return;

    this._isShown = false;
    this._setEscapeEvent();
    $(document).off('focusin.bs.modal');

    $(this._element)
      .removeClass(ClassName.SHOW)
      .off('click.dismiss.bs.modal');

    var transition = $(this._element).hasClass(ClassName.FADE);
    if (transition) {
      var duration = Util.getTransitionDurationFromElement(this._element);
      $(this._element).one(Util.TRANSITION_END, $.proxy(this._hideModal, this)).emulateTransitionEnd(duration);
    } else {
      this._hideModal();
    }
  };

  Modal.prototype._showElement = function (relatedTarget) {
    var _this = this;
    var transition = $(this._element).hasClass(ClassName.FADE);

    if (!this._element.parentNode || this._element.parentNode.nodeType !== Node.ELEMENT_NODE) {
      document.body.appendChild(this._element);
    }

    this._element.style.display = 'block';
    this._element.removeAttribute('aria-hidden');
    this._element.scrollTop = 0;

    if (transition) {
      Util.reflow(this._element);
    }

    $(this._element).addClass(ClassName.SHOW);

    if (this._config.focus) {
      this._enforceFocus();
    }

    var transitionComplete = function () {
      if (_this._config.focus) { _this._element.focus(); }
      $(this._element).trigger($.Event('shown.bs.modal', { relatedTarget: relatedTarget }));
    }.bind(this);

    if (transition) {
      var duration = Util.getTransitionDurationFromElement(this._dialog);
      $(this._dialog).one(Util.TRANSITION_END, transitionComplete).emulateTransitionEnd(duration);
    } else {
      transitionComplete();
    }
  };

  Modal.prototype._hideModal = function () {
    var _this = this;
    this._element.style.display = 'none';
    this._element.setAttribute('aria-hidden', true);

    this._showBackdrop(function () {
      $(document.body).removeClass(ClassName.OPEN);
      _this._resetScrollbar();
      $(_this._element).trigger('hidden.bs.modal');
    });
  };

  Modal.prototype._enforceFocus = function () {
    var _this = this;
    $(document).off('focusin.bs.modal').on('focusin.bs.modal', function (event) {
      if (document !== event.target && _this._element !== event.target && !$(_this._element).has(event.target).length) {
        _this._element.focus();
      }
    });
  };

  Modal.prototype._setEscapeEvent = function () {
    var _this = this;
    if (this._isShown && this._config.keyboard) {
      $(this._element).on('keydown.dismiss.bs.modal', function (event) {
        if (event.which === ESCAPE_KEYCODE) {
          event.preventDefault();
          _this.hide();
        }
      });
    } else if (!this._isShown) {
      $(this._element).off('keydown.dismiss.bs.modal');
    }
  };

  Modal.prototype._showBackdrop = function (callback) {
    var _this   = this;
    var animate = $(this._element).hasClass(ClassName.FADE) ? ClassName.FADE : '';

    if (this._isShown && this._config.backdrop) {
      this._backdrop = document.createElement('div');
      this._backdrop.className = ClassName.BACKDROP;
      if (animate) this._backdrop.classList.add(animate);
      $(this._backdrop).appendTo(document.body);

      // Close on backdrop click (cursor:pointer fix is in CSS for iOS)
      $(this._element).on('click.dismiss.bs.modal', function (event) {
        if (_this._ignoreBackdropClick) { _this._ignoreBackdropClick = false; return; }
        if (event.target !== event.currentTarget) return;
        _this._config.backdrop === 'static' ? _this._element.focus() : _this.hide();
      });

      if (animate) Util.reflow(this._backdrop);
      $(this._backdrop).addClass(ClassName.SHOW);

      if (!callback) return;
      if (!animate) { callback(); return; }

      var duration = Util.getTransitionDurationFromElement(this._backdrop);
      $(this._backdrop).one(Util.TRANSITION_END, callback).emulateTransitionEnd(duration);

    } else if (!this._isShown && this._backdrop) {
      $(this._backdrop).removeClass(ClassName.SHOW);

      var callbackRemove = function () {
        _this._removeBackdrop();
        if (callback) callback();
      };

      if ($(this._element).hasClass(ClassName.FADE)) {
        var dur = Util.getTransitionDurationFromElement(this._backdrop);
        $(this._backdrop).one(Util.TRANSITION_END, callbackRemove).emulateTransitionEnd(dur);
      } else {
        callbackRemove();
      }
    } else if (callback) {
      callback();
    }
  };

  Modal.prototype._removeBackdrop = function () {
    if (this._backdrop) {
      $(this._backdrop).remove();
      this._backdrop = null;
    }
  };

  Modal.prototype._checkScrollbar = function () {
    var rect = document.body.getBoundingClientRect();
    this._isBodyOverflowing = rect.left + rect.right < window.innerWidth;
    this._scrollbarWidth = this._getScrollbarWidth();
  };

  Modal.prototype._setScrollbar = function () {
    if (this._isBodyOverflowing) {
      var pad = parseInt($(document.body).css('padding-right') || 0, 10);
      $(document.body).css('padding-right', pad + this._scrollbarWidth);
    }
  };

  Modal.prototype._resetScrollbar = function () {
    $(document.body).css('padding-right', '');
  };

  Modal.prototype._getScrollbarWidth = function () {
    var scrollDiv = document.createElement('div');
    scrollDiv.className = ClassName.SCROLLBAR_MEASURER;
    document.body.appendChild(scrollDiv);
    var w = scrollDiv.getBoundingClientRect().width - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return w;
  };

  // ─── jQuery plugin ────────────────────────────────────────────────────────

  function Plugin(option, _relatedTarget) {
    return this.each(function () {
      var $this   = $(this);
      var data    = $this.data(DATA_KEY);
      var options = $.extend({}, Default, $this.data(), typeof option === 'object' && option);

      if (!data) { $this.data(DATA_KEY, (data = new Modal(this, options))); }
      if (typeof option === 'string') { data[option](_relatedTarget); }
      else if (options.show) { data.show(_relatedTarget); }
    });
  }

  var old = $.fn[NAME];
  $.fn[NAME]             = Plugin;
  $.fn[NAME].Constructor = Modal;
  $.fn[NAME].noConflict  = function () { $.fn[NAME] = old; return Plugin; };

  // ─── Data-API ─────────────────────────────────────────────────────────────

  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
    var $this   = $(this);
    var href    = $this.attr('href');
    var $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\s]+$)/, '')));
    var option  = $target.data(DATA_KEY) ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data());

    if ($this.is('a')) e.preventDefault();

    $target.one('show.bs.modal', function (showEvent) {
      if (showEvent.isDefaultPrevented()) return;
      $target.one('hidden.bs.modal', function () {
        if ($this.is(':visible')) $this.trigger('focus');
      });
    });

    Plugin.call($target, option, this);
  });

}(jQuery);
